import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuthState } from "../../Context";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import MainLayout from "../Common/MainLayout";

function TableauComponent() {
  const theme = useTheme();
  // const { id } = useParams();
  const { state } = useLocation();
  console.log("state", state);
  const view = state.view;
  const workbook_url = state.workbook_url;
  const site = state.site;
  const ref = useRef(null);
  let tableauViz = null;

  const { session } = useAuthState();

  const initViz = async () => {
    const serverName = "tableau.healthperform.com"; // replace with your server name if different
    let vizUrlWithTicket = "";
    try {
      // this is not async function
      // TODO: no need to save session in state, it can be retrieved from user.getSession.
      const token = session.getIdToken().getJwtToken();
      console.log("getting trust ticket");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/getTableauTrustedTicket?site=${site}`,
        {
          headers: {
            //`Bearer ${token}` also works because backend checks for Bearer and removes it if present
            authorizationToken: token,
          },
        }
      );
      const trustedTicket = response.data.ticket;
      console.log("trustedTicket received");

      vizUrlWithTicket = `https://${serverName}/trusted/${trustedTicket}/t/${site}/views/${workbook_url}/${view}?:embed=y&:comments=no&:toolbar=yes&:refresh=yes`;
    } catch (error) {
      console.error(
        "An error occurred while fetching the trusted ticket:",
        error
      );
      // Handle the error appropriately in your application.
    }
    const options = {
      hideTabs: true,
      hideToolbar: true,
      width: Math.max(theme.tableauEmbedView.minWidth, window.innerWidth),
      height: Math.max(
        theme.tableauEmbedView.minHeight,
        window.innerHeight - theme.navbarHeight
      ),
      onFirstInteractive: () => {
        console.log("Run this code when the viz has finished loading.");
        // const width = Math.max(theme.tableauEmbedView.minWidth, window.innerWidth)
        // const height = Math.max(
        //   theme.tableauEmbedView.minHeight,
        //   window.innerHeight - theme.navbarHeight
        // );
        // console.log("width", width, "height", height);
        // console.log("tableauViz.width", tableauViz.width, "tableauViz.height", tableauViz.height)
        // var sheet = tableauViz.getWorkbook().getActiveSheet();
        // sheet.changeSizeAsync(
        // {"behavior": "EXACTLY", "maxSize": { "height": height, "width": width }})
        // .then(tableauViz.setFrameSize(parseInt(width, 10), parseInt(height, 10)));
      },
    };

    // Check if a viz already exists in the div, if so, clean it up
    if (tableauViz !== null) {
      tableauViz.dispose();
    }

    // Initialize the Tableau dashboard
    tableauViz = new window.tableau.Viz(ref.current, vizUrlWithTicket, options);
  };

  //TODO: Refactor this
  const handleResize = () => {
    const width = Math.max(theme.tableauEmbedView.minWidth, window.innerWidth);
    const height = Math.max(
      theme.tableauEmbedView.minHeight,
      window.innerHeight - theme.navbarHeight
    );
    tableauViz.setFrameSize(parseInt(width, 10), parseInt(height, 10));
    console.log("resizing window to width: ", width, " height: ", height);
    // if (tableauViz) {
    //   var sheet = tableauViz.getWorkbook().getActiveSheet();
    //   sheet.changeSizeAsync(
    //     {"behavior": "EXACTLY", "maxSize": { "height": height, "width": width }}
    //   )
    //   .then(tableauViz.setFrameSize(parseInt(width, 10), parseInt(height, 10)));
    // }
  };

  useEffect(() => {
    // Initialize the viz
    const initializeViz = async () => {
      await initViz();
    };

    initializeViz();

    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => {
      console.log("Running cleanup for Tableau Viz");
      if (tableauViz !== null) {
        try {
          tableauViz.dispose(); // Attempt to dispose of the Tableau visualization
          console.log("Tableau Viz disposed");
        } catch (error) {
          console.error("Error disposing Tableau Viz:", error);
          // Handle any errors that occur during the dispose, if necessary
        }
      }
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <MainLayout>
      <div ref={ref}></div>
    </MainLayout>
  );
}

export default TableauComponent;
